import { Link } from 'react-router-dom';
import './PricingSection.css';

const plans = [
  {
    name: 'Starter',
    price: 9.99,
    description: 'Best for experimentation, quick trials, and learning workflows.',
    features: [
      { label: 'Active Time', value: '100 hours/mo' },
      { label: 'AI Credits', value: '600/mo' },
      { label: 'Memory', value: '2 GB' },
    ],
    cta: 'Start with Starter',
    popular: false,
  },
  {
    name: 'Pro',
    price: 39.99,
    description: 'For power users who need more capacity',
    features: [
      { label: 'Active Time', value: '730 hours/mo' },
      { label: 'AI Credits', value: '2,000/mo' },
      { label: 'Memory', value: '2 GB' },
    ],
    cta: 'Go Pro',
    popular: true,
  },
  {
    name: 'Plus',
    price: 59.99,
    description: 'Full month coverage for heavy workloads',
    features: [
      { label: 'Active Time', value: '730 hours/mo', highlight: 'Full month' },
      { label: 'AI Credits', value: '10,000/mo' },
      { label: 'Memory', value: '4 GB' },
    ],
    cta: 'Go Plus',
    popular: false,
  },
];

export default function PricingSection() {
  return (
    <section id="pricing" className="landing-section pricing-section">
      <div className="landing-section-inner">
        <div className="section-header animate-on-scroll">
          <h2 className="section-title">Simple, Transparent Pricing</h2>
          <p className="section-subtitle">
            Monthly subscription. Hours and credits reset each billing cycle.
          </p>
        </div>

        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div
              key={plan.name}
              className={`pricing-card animate-on-scroll animate-delay-${index + 1} ${
                plan.popular ? 'pricing-popular' : ''
              }`}
            >
              {plan.popular && (
                <div className="popular-badge">Most Popular</div>
              )}
              <div className="pricing-header">
                <h3 className="pricing-name">{plan.name}</h3>
                <div className="pricing-price">
                  <span className="price-currency">$</span>
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-period">/month</span>
                </div>
                <p className="pricing-description">{plan.description}</p>
              </div>

              <ul className="pricing-features">
                {plan.features.map((feature) => (
                  <li key={feature.label} className="pricing-feature">
                    <span className="feature-check">✓</span>
                    <span className="feature-label">{feature.label}:</span>
                    <span className="feature-value">
                      {feature.value}
                      {feature.highlight && (
                        <span className="feature-highlight">{feature.highlight}</span>
                      )}
                    </span>
                  </li>
                ))}
              </ul>

              <Link
                to="/login"
                className={`btn btn-large ${
                  plan.popular ? 'btn-primary' : 'btn-secondary'
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>

        <p className="pricing-note animate-on-scroll">
          <span className="note-icon">💡</span>
          No free trial. Start with the Starter plan for quick experiments and testing.
        </p>
      </div>
    </section>
  );
}
